/**
 * Copyright IBM Corp. 2022, 2026
 */

import { InlineVideo } from 'components/inline-video'
import s from './style.module.css'

interface InlineVideoBlockProps {
	url: string
	description?: string
	aspectRatio?: string
	showAccentColor?: boolean
}

export default function InlineVideoBlock({
	url,
	description,
	aspectRatio,
	showAccentColor,
}: InlineVideoBlockProps) {
	return (
		<section className={s.videoBlock}>
			<InlineVideo
				url={url}
				description={description}
				gradientPosition={false}
				aspectRatio={aspectRatio}
				showAccent={showAccentColor}
			/>
		</section>
	)
}
